<template>
  <div class="vip_container">
    <div class="bookvip-banner"></div>
    <div class="bookvip-buy">
      <a href="javascript:void(0)" @click="goPayPage('elec_book_vip')">立即购买</a>
    </div>
    <div class="bookvip">
      <table cellspacing="1" cellpadding="1">
        <tr>
          <td>个人用户</td>
          <td>
            <h2>免费试用</h2>
            <p><span>0</span>元/年</p>
            <!-- <a @click="toUpload()">免费使用</a> -->
          </td>
          <td>
            <h2>个人体验版</h2>
            <p><span>399</span>元/年</p>
            <!-- <a href="javascript:void(0)" @click="goPayPage('elec_book_vip')">立即购买</a> -->
          </td>
          <td>
            <h2>个人基础版</h2>
            <p><span>999</span>元/年</p>
            <!-- <a href="javascript:void(0)" @click="goPayPage('elec_book_prof')">立即购买</a> -->
          </td>
        </tr>
        <tr>
          <td>
            <span>出版传媒企业用户</span>
          </td>
          <td colspan="4">
            <p>
              <span>支持组建团队协同创作、支持作品运营、数据分析、支持品牌广告传播、更丰富的作品编辑能力，敬请咨询。</span>
            </p>
            <p style="display: flex; gap: 20px; justify-content: center">
              <span>周老师</span>
              <span>座机：010-82531751</span>
              <span>手机/微信：13436861163</span>
              <span>QQ：873504364</span>
            </p>
          </td>
        </tr>
        <tr>
          <td class="table-title" colspan="4">作品管理</td>
        </tr>
        <!-- <tr>
          <td>存储空间</td>
          <td>1G<a class="addstorage" href="javascript:void(0)" @click="goPayPage('elec_book_space')">+ 增加空间</a></td>
          <td>5G<a class="addstorage" href="javascript:void(0)" @click="goPayPage('elec_book_space')">+ 增加空间</a></td>
          <td>10G<a class="addstorage" href="javascript:void(0)" @click="goPayPage('elec_book_space')">+ 增加空间</a></td>
          <td>100G<a class="addstorage" href="javascript:void(0)" @click="goPayPage('elec_book_space')">+ 增加空间</a></td>
          <td>200G<a class="addstorage" href="javascript:void(0)" @click="goPayPage('elec_book_space')">+ 增加空间</a></td>
          <td>400G<a class="addstorage" href="javascript:void(0)" @click="goPayPage('elec_book_space')">+ 增加空间</a></td>
          <td>600G<a class="addstorage" href="javascript:void(0)" @click="goPayPage('elec_book_space')">+ 增加空间</a></td>
        </tr> -->
        <tr>
          <td>存储空间</td>
          <td>1G</td>
          <td>20G</td>
          <td>50G</td>
        </tr>
        <tr>
          <td>作品数量</td>
          <td>10个</td>
          <td>50个</td>
          <td>100个</td>
        </tr>
        <tr>
          <td>书本页数</td>
          <td>无限制</td>
          <td>无限制</td>
          <td>无限制</td>
        </tr>
        <tr>
          <td>专辑总数量</td>
          <td>1个（3本书）</td>
          <td>5个</td>
          <td>10个</td>
        </tr>
        <tr>
          <td>图书馆总数量</td>
          <td><i>——</i></td>
          <td>1个</td>
          <td>3个</td>
        </tr>
        <tr>
          <td>视频推荐</td>
          <td>1个</td>
          <td>5个</td>
          <td>10个</td>
        </tr>
        <tr>
          <td>访问数据</td>
          <td><i>——</i></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td class="table-title" colspan="4">作品编辑</td>
        </tr>
        <tr>
          <td>添加电子书目录</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>自动生成电子书目录</td>
          <td><i>——</i></td>
          <td><i>——</i></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>导航按钮样式选择</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>开启翻书音效</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>设置背景音乐</td>
          <td><i>——</i></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>自定义背景图</td>
          <td><i>——</i></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>自定义Hot/New等标签</td>
          <td><i>——</i></td>
          <td><i>——</i></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td class="table-title" colspan="4">传播方式</td>
        </tr>
        <tr>
          <td>网页链接</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>不同尺寸二维码下载</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td class="table-title" colspan="4">作品阅读</td>
        </tr>
        <tr>
          <td>缩略图导览</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>文字内容检索</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>浏览位置记忆</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>生成作品海报</td>
          <td><i>——</i></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td class="table-title" colspan="4">品牌权限</td>
        </tr>
        <tr>
          <td>自定义微信分享描述</td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
        <tr>
          <td>更换加载页logo图片</td>
          <td><i>——</i></td>
          <td><i>——</i></td>
          <td><img src="../assets/imgs/vip_confirm.png" /></td>
        </tr>
      </table>

      <h1 v-if="false">增值服务</h1>

      <table cellspacing="1" cellpadding="1" v-if="false">
        <tr class="table-title">
          <td>服务类型</td>
          <td>价格</td>
          <td colspan="4">涵盖功能</td>
        </tr>
        <tr>
          <td>阅读体验升级包</td>
          <td>
            <p>请联系产品经理</p>
            <p>周老师：010-82531751</p>
            <p>贾老师：010-82531412</p>
          </td>
          <td colspan="4">
            <p>通过方正飞翔发布流版结合电子书</p>
            <p>支持流式电子书在线听读</p>
            <p>支持下载ePub</p>
          </td>
        </tr>
        <tr>
          <td>空间扩容包A</td>
          <td>80元</td>
          <td colspan="4">
            <p>1G存储空间扩容，有效期1年</p>
          </td>
        </tr>
        <tr>
          <td>空间扩容包B</td>
          <td>3000元</td>
          <td colspan="4">
            <p>100G存储空间扩容，有效期1年</p>
          </td>
        </tr>
        <tr>
          <td>空间扩容包C</td>
          <td>10000元</td>
          <td colspan="4">
            <p>500G存储空间扩容，有效期1年</p>
          </td>
        </tr>
        <tr>
          <td>作品数量扩展包</td>
          <td>500元</td>
          <td colspan="4">
            <p>增加100个作品，永久有效</p>
          </td>
        </tr>
        <tr>
          <td>专辑扩展包</td>
          <td>100元</td>
          <td colspan="4">
            <p>增加一个专辑，永久有效</p>
          </td>
        </tr>
        <tr>
          <td>图书馆扩展包</td>
          <td>200元</td>
          <td colspan="4">
            <p>增加一个图书馆，永久有效</p>
          </td>
        </tr>
      </table>
    </div>
    <div class="bookvip-buy">
      <a href="javascript:void(0)" @click="goPayPage('elec_book_vip')">立即购买</a>
    </div>
    <comFooter></comFooter>
  </div>
</template>

<script>
import comFooter from '@components/commonFooter/index.vue'
import { isLogin } from '@/utils'
export default {
  name: 'openvip',
  methods: {
    toUpload() {
      this.$router.push('/upload')
    },
    goPayPage(payload) {
      const uploadBaseUrl = process.env.NODE_ENV === 'development' ? location.origin : window.PROJECT_CONFIG.BASE_URL
      const url = uploadBaseUrl + '/product/cloudReadVipBuyUrl.jhtml'
      window.open(url, '_blank')
      // if (this.userName) {
      //   this.$router.push({
      //     path: '/goPayPage',
      //     query: {
      //       buyType: payload
      //     }
      //   })
      // }
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },
  mounted() {
    isLogin()
  },
  components: {
    comFooter
  }
}
</script>

<style lang="scss">
.vip_container {
  width: 100%;
  overflow: auto;
  .bookvip-banner {
    background: url('../assets/imgs/vip_bg@2x.png') no-repeat center;
    // background-size: cover;
    height: 500px;
  }
  .bookvip-buy {
    width: 1300px;
    text-align: center;
    margin: -500px auto 50px auto;
    a {
      width: 300px;
      line-height: 50px;
      display: inline-block;
      color: #fff;
      border-radius: 50px;
      background: #fab15e;
      text-decoration: none;
      font-weight: bold;
      margin-top: 150px;
      cursor: pointer;
      font-size: 20px;
      -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      -o-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      -ms-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
    a:hover {
      background: #ffc16c;
      -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
      -moz-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
      -o-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
      -ms-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }
  }
  .bookvip {
    width: 1100px;
    margin: 0 auto 400px auto;
    h1 {
      margin: 50px 0 30px 0;
      font-size: 30px;
      text-align: center;
    }
    table {
      width: 100%;
      text-align: center;
      background-color: #eaeaea;
      border-radius: 10px;
      overflow: hidden;
      -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      -o-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      -ms-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      tr td:first-child {
        font-weight: bold;
      }
      tr:first-child {
        background-color: #fff7ed;
      }
      tr:first-child {
        font-weight: bold;
      }
      tr:first-child h2 {
        font-weight: bold;
        font-size: 18px;
      }
      tr:first-child p {
        color: #fab15e;
        line-height: 24px;
      }
      tr:first-child p span {
        font-size: 36px;
      }
      tr:first-child td:nth-child(n + 1) {
        width: 160px;
      }
      tr:nth-child(2) {
        p {
          line-height: 20px;
          font-size: 16px;
        }
      }
      tr:nth-child(4) span {
        margin: 0 20px;
      }
      td.qiye p {
        line-height: 13px;
        text-align: left;
        margin-right: -8em;
        margin-left: 80px;
      }
      td.qiye p:last-child {
        text-indent: 8em;
      }
      tr {
        line-height: 50px;
      }
      tr:nth-child(odd) {
        background: #fff7ed;
      }
      tr:nth-child(even) {
        background: #fff;
      }
      tr i {
        color: #cecece;
      }
      tr img {
        width: 30px;
        vertical-align: middle;
      }
      .table-title {
        background: #eee !important;
        font-weight: bold;
      }
      a.addstorage {
        display: block;
        width: 100px;
        line-height: 24px;
        border: 1px solid #fab15e;
        border-radius: 20px;
        color: #fab15e;
        font-size: 16px;
        font-weight: bold;
        text-decoration: none;
        margin: 0 auto 20px auto;
        background: #fff;
      }
      a.addstorage:hover {
        background: #fab15e;
        color: #fff;
      }
      tr:first-child a.qiye {
        background: #fff;
        border: 1px solid #fab15e;
        color: #fab15e;
      }
    }
    table:nth-child(2) tr:first-child td:first-child {
      background-color: #eee;
    }
  }
}
</style>
